import {Select} from "antd";
import React from "react";

export default ({sizes, ...props}) => {
  let allOptions = [
    { value: "YS", label: "Youth S" },
    { value: "YM", label: "Youth M" },
    { value: "YL", label: "Youth L" },
    { value: "YEL", label: "Youth XL" },
    { value: "XS", label: "Adult XS" },
    { value: "S", label: "Adult S" },
    { value: "M", label: "Adult M" },
    { value: "L", label: "Adult L" },
    { value: "XL", label: "Adult XL" },
    { value: "XXL", label: "Adult XXL" },
    { value: "XXXL", label: "Adult XXXL" },
  ]

  let options = sizes
    ? allOptions.filter(option => sizes.includes(option.value))
    : allOptions

  return <Select style={{width: "100%"}} options={options} {...props}/>
}

